"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$articleTitle = void 0;
const factory_1 = __importDefault(require("../factory"));
const lexical_1 = require("./lexical");
exports.$articleTitle = factory_1.default
    .withName("articleTitle")
    .sequence(c => c
    .and(r => r
    .choice(c => c
    .or(r => r
    .regExp(new RegExp(`^第[${lexical_1.kanjiDigits}]+[条條](?:[のノ][${lexical_1.kanjiDigits}]+)*`)) // e.g. "第十二条", "第一条の二", "第一条の二の三"
)
    .or(r => r
    .regExp(new RegExp(`^第[${lexical_1.arabicDigits}]+[条條](?:[のノ][${lexical_1.arabicDigits}]+)*`)) // e.g. "第１２条", "第1条の2", "第１条の２の３"
)), "title")
    .action(({ title }) => {
    return { value: title, errors: [] };
}));
exports.default = exports.$articleTitle;
//# sourceMappingURL=$articleTitle.js.map